import React, { useEffect } from "react";
import { MapContainer, TileLayer, Marker, useMap, useMapEvents } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

// ✅ Custom marker icon
const markerIcon = new L.Icon({
  iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  iconRetinaUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
});

/**
 * Forces Leaflet map to recenter when lat/lng props change
 */
function RecenterMap({ lat, lng }) {
  const map = useMap();

  useEffect(() => {
    if (lat && lng) {
      map.setView([lat, lng], map.getZoom(), {
        animate: true,
      });
    }
  }, [lat, lng, map]);

  return null;
}

/**
 * Handles map clicks and renders marker
 */
function LocationMarker({ lat, lng, onChange }) {
  useMapEvents({
    click(e) {
      onChange?.(e.latlng.lat, e.latlng.lng);
    },
  });

  return lat && lng ? <Marker position={[lat, lng]} icon={markerIcon} /> : null;
}

export default function LocationPickerMap({ lat, lng, onChange }) {
  // Fallback center (Tbilisi) to avoid crashes
  const safeLat = lat ?? 41.7151;
  const safeLng = lng ?? 44.8271;

  return (
    <MapContainer
      center={[safeLat, safeLng]}
      zoom={13}
      style={{ height: 300, width: "100%" }}
      scrollWheelZoom
    >
      <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />

      <RecenterMap lat={lat} lng={lng} />
      <LocationMarker lat={lat} lng={lng} onChange={onChange} />
    </MapContainer>
  );
}
